import React from "react";
import { InfoSection } from "../../components";
import { homeObjThree } from "./Data";

const SignUp = () => {
  return (
    <>
      <InfoSection {...homeObjThree} />
    </>
  );
};

export default SignUp;
